module.exports = __webpack_public_path__ + "img/61.b45ac4b8.png";